<template>
  <v-col
    align-self="start"
    cols="12"
    md="5"
    class="mt-12 pl-8"
    style="z-index: 0; margin-top: 120px !important;"
  >
    <template v-if="loginParams.companylogo && loginParams.companylogo.show">
      <a
        target="_blank"
        :href="loginParams.companylogo.href"
        class="d-block"
      >
        <img
          :src="loginParams.companylogo.src"
          :alt="loginParams.companylogo.title"
          width="200"
          class="ml-12 mt-6 mb-3"
          loading="lazy"
        />
      </a>
    </template>

    <template v-if="loginParams.welcomeMessage && loginParams.welcomeMessage.show">
      <v-col cols="12" class="px-0">
        <h4 style="color: #154669;"
          class="font-weight-medium ml-12 my-1 mb-3 "
          v-html="loginParams.welcomeMessage.customText || $t('DocSeriesProductsOffer')"
        />

        <v-row class="mx-0" no-gutters>
          <v-col cols="12" md="6" sm="6" class="d-flex align-center">
            <v-btn
              target="_blank"
              :href="loginParams.otherProducts.linkButton.href"
              class="mt-4 ml-12 gradient-btn white--text font-weight-bold"
              outlined
              width="280"
            >
              {{
                loginParams.otherProducts.linkButton.customText || $t("ViewProducts")
              }}
            </v-btn>
          </v-col>

          <v-col cols="12" sm="6" class="d-flex justify-center align-center">
            <img
              :src="loginParams.welcomeMessage.src"
              width="120"
              class="mt-4 ml-12"
              loading="lazy"
            />
          </v-col>
        </v-row>
      </v-col>
    </template>

    <template v-if="loginParams.otherProducts && loginParams.otherProducts.showProducts">
      <v-row class="my-4 mx-0">
        <v-col
          cols="12"
          sm="6"
          md="4"
          v-for="(product, index) in loginParams.otherProducts.products"
          :key="`product-${index}`"
          class="d-flex justify-center"
        >
          <a
            target="_blank"
            :href="product.href"
            class="d-block"
          >
            <img
              :src="product.src"
              :alt="product.title"
              width="100"
              loading="lazy"
            />
          </a>
        </v-col>
      </v-row>
    </template>
  </v-col>
</template>

<script>
export default {
    name: 'LoginBrandingSection',
    props: {
        loginParams: {
            type: Object,
            required: true,
            default: () => ({})
        }
    }
};
</script>

<style scoped lang="css">
.gradient-btn {
  background: linear-gradient(45deg,#154669, #01579b, #006064, #00838F);
  background-size: 200% 200%;
  background-position: center;
  border: none;
  transition: background-position 0.3s ease;
}

.gradient-btn:hover {
  background-position: left center;
}
</style>